<template>
  <i class="tm-anchor" v-if="isRelevant">
    <template v-if="showVisualAnchors">
      <tm-visual-anchor
        v-for="time in visualAnchorsTimes"
        :key="time"
        :time="time"
      />
    </template>
    <tm-beat-anchor
      v-for="beat in beatsDataObjs"
      :key="beat.time"
      :time="beat.time"
      :isDownBeat="beat.downbeat"
      :styleObj="beat.styleObj"
      :isUsed="beat.isUsed"
    />
  </i>
</template>

<script>
import tmVisualAnchor from './tmVisualAnchor.vue';
import tmBeatAnchor from './tmBeatAnchor.vue';
import { mapGetters, mapState } from 'vuex';
import { getVisualAnchorTimes } from '../../../api/tapi';
import gridMixin from '../../grid.mixin';

export default {
  name: 'tm-anchors',
  mixins: [gridMixin],
  components: { tmVisualAnchor, tmBeatAnchor },

  data() {
    return {
      endTimes: new Set(),
    };
  },

  computed: {
    ...mapState('timemachine', {
      dndEscort: (state) => state.dndEscort,
      trackLayer: (state) => state.trackLayer,
    }),
    ...mapGetters('timemachine', ['getBgBeats']),

    isRelevant() {
      // @note: reserved for piping audio anchors (or whatever anchors)
      return (
        this.dndEscort.showVisualAnchors ||
        (this.trackLayer.visual.length && this.getBgBeats.length)
      );
    },

    showVisualAnchors() {
      return this.dndEscort.showVisualAnchors;
    },

    visualAnchorsTimes() {
      return getVisualAnchorTimes(this.trackLayer.visual);
    },

    endSegmentTimes() {
      this.endTimes.clear();

      for (const track of this.trackLayer.visual) {
        this.endTimes.add(track.data.displayEndTime);
      }

      return this.endTimes;
    },

    beatsDataObjs() {
      let rv = [];

      if (this.gridEstablished) {
        rv = this.getBgBeats.map((beat) => {
          const point = this.$_time2point(beat.time, true);
          return {
            styleObj: {
              transform: `translate3d(${point.x}px, ${point.y}px,0)`,
            },
            time: beat.time,
            downbeat: beat.downbeat,
            isUsed: this.endSegmentTimes.has(beat.time),
          };
        });
      }

      return rv;
    },
  },
};
</script>

<style lang="scss">
.tm-timemachine > .tm-anchor {
  position: absolute;
  top: 0;
}
</style>
